/**
 * Uniform response envelope produced by the Go API.
 *
 * Success: `{ "data": T }`
 * Failure: `{ "error": { "code": "...", "message": "...", "details"?: ... } }`
 */
export interface ApiErrorBody {
  code: ApiErrorCode | string;
  message: string;
  details?: Record<string, string[]> | Record<string, unknown>;
}

export interface ApiSuccess<T> {
  data: T;
}

export interface ApiFailure {
  error: ApiErrorBody;
}

export type ApiResponse<T> = ApiSuccess<T> | ApiFailure;

export type ApiErrorCode =
  | "VALIDATION_ERROR"
  | "UNAUTHENTICATED"
  | "FORBIDDEN"
  | "NOT_FOUND"
  | "CONFLICT"
  | "RATE_LIMITED"
  | "CSRF_INVALID"
  | "ACCOUNT_BANNED"
  | "EMAIL_NOT_VERIFIED"
  | "INVALID_CREDENTIALS"
  | "PAYMENT_METHOD_DISABLED"
  | "CART_EMPTY"
  | "PRODUCT_UNAVAILABLE"
  | "OUT_OF_STOCK"
  | "DISCOUNT_INVALID"
  | "INTERNAL_ERROR";

export interface Paginated<T> {
  items: T[];
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
}

export function isApiFailure<T>(res: ApiResponse<T>): res is ApiFailure {
  return typeof res === "object" && res !== null && "error" in res;
}
